import React from "react";

export default function ToolTips(props) {
  const action = props?.action;
  const items = props?.items;
  const converNumberTo2Decimal = (number) => {
    if (number) {
      return Number(number).toFixed(2);
    }
  };
  if (action === "chart") {
    return (
      <div>
        <img
          src={`https://www.icharts.in/ShowChart.php?symbol=${items?.symbol}&uind1=EMA&uind1_param=5&pr_period=1M&lind1=Vol&lind1_param=20&uind2=SMA&uind2_param=10&lind2=RSI&lind2_param=3&lind3=SStoch&lind3_param=5,3`}
          alt={items?.symbol}
        />
      </div>
    );
  }
  if (action === "technical") {
    return (
      <table className="table table-bordered font-white">
        <tbody>
          <tr className="text-center">
            <th colSpan="4">{items?.symbol}</th>
          </tr>
          <tr>
            <th>LTP</th>
            <td>{converNumberTo2Decimal(items?.l)}</td>
            <th>%CHG</th>
            <td>{converNumberTo2Decimal(items?.cp)}</td>
          </tr>
          <tr>
            <th>Vol</th>
            <td>{converNumberTo2Decimal(items?.vo)}</td>
            <th>%DEL</th>
            <td>{converNumberTo2Decimal(items?.DELIV_PER)}</td>
          </tr>
          <tr>
            <th>Signal</th>
            <td>{items?.signal}</td>
            <th>Buy Above</th>
            <td>{converNumberTo2Decimal(items?.bintraday)}</td>
          </tr>
          <tr>
            <th>Rec Price</th>
            <td>{converNumberTo2Decimal(items?.rec_price)}</td>
            <th>Sell Below</th>
            <td>{converNumberTo2Decimal(items?.sintraday)}</td>
          </tr>
          <tr>
            <th>Rec Time</th>
            <td>{items?.rec_time}</td>
            <th>ATP</th>
            <td>{converNumberTo2Decimal(items?.atp)}</td>
          </tr>
          <tr>
            <th>Counter</th>
            <td>{items?.counter}</td>
            <th>Rank</th>
            <td>{items?.stocksRanking}</td>
          </tr>
        </tbody>
      </table>
    );
  }
  if (action === "fundamental") {
    return (
      <table className="table table-bordered font-white">
        <tbody>
          <tr className="text-center">
            <th colSpan="4">{items?.symbol}</th>
          </tr>
          <tr>
            <th>NPM</th>
            <td>{converNumberTo2Decimal(items?.NetProfitMargin)}</td>
            <th>1 Yr EPS Growth</th>
            <td>{converNumberTo2Decimal(items?.["1YHistoricalEPSGrowth"])}</td>
          </tr>
          <tr>
            <th>ROCE</th>
            <td>{converNumberTo2Decimal(items?.ROCE)}</td>
            <th>5 Yr EPS Growth</th>
            <td>{converNumberTo2Decimal(items?.["5YHistoricalEPSGrowth"])}</td>
          </tr>
          <tr>
            <th>ROE</th>
            <td>{converNumberTo2Decimal(items?.ReturnonEquity)}</td>
            <th>1 Yr Revenue Growth</th>
            <td>{converNumberTo2Decimal(items?.["1YForwardRevenueGrowth"])}</td>
          </tr>
          <tr>
            <th>EBITDA Margin</th>
            <td>{converNumberTo2Decimal(items?.EBITDAMargin)}</td>
            <th>5 Yr Revenue Growth</th>
            <td>
              {converNumberTo2Decimal(items?.["5YHistoricalRevenueGrowth"])}
            </td>
          </tr>
          <tr>
            <th>ROA</th>
            <td>{converNumberTo2Decimal(items?.ReturnonAssets)}</td>
            <th>DEBT to Equity </th>
            <td>{converNumberTo2Decimal(items?.DebttoEquity)}</td>
          </tr>
          <tr>
            <th>Valuation Rank </th>
            <td>{items?.fundamentalValue}</td>
            <th>Fundamental Rank</th>
            <td>{items?.fundamentalRanking}</td>
          </tr>
        </tbody>
      </table>
    );
  }
  if (action === "fnO") {
    return (
      <table className="table table-bordered font-white">
        <tbody>
          <tr className="text-center">
            <th colSpan="4">{items?.symbol}</th>
          </tr>
          <tr>
            <td colSpan={2}>
              <button className="btn btn-success mr-2">
                Highest OI Strike Call :{items?.cestrike}
              </button>
            </td>
            <td colSpan={2}>
              <button className="btn btn-danger mr-2">
                Highest OI Strike Put : {items?.pestrike}
              </button>
            </td>
          </tr>
          <tr>
            <th>Parameter</th>
            <th>Value</th>
            <th>Change</th>
            <th>%CHG</th>
          </tr>
          <tr>
            <th>Contracts</th>
            <td>{converNumberTo2Decimal(items?.contracts)}</td>
            <td>{converNumberTo2Decimal(items?.preContracts)}</td>
            <td>{converNumberTo2Decimal(items?.preContractsPer)}</td>
          </tr>
          <tr>
            <th>OI</th>
            <td>{converNumberTo2Decimal(items?.open_int)}</td>
            <td>{converNumberTo2Decimal(items?.preFuture)}</td>
            <td>{converNumberTo2Decimal(items?.preFuturePer)}</td>
          </tr>
          <tr>
            <th>Future Price</th>
            <td>{converNumberTo2Decimal(items?.close)}</td>
            <td>{converNumberTo2Decimal(items?.preCloseChange)}</td>
            <td>{converNumberTo2Decimal(items?.preClosePer)}</td>
          </tr>
          <tr className="text-center">
            <th colSpan="4">
              <b> {items?.foptionchainSignal}</b>
            </th>
          </tr>
        </tbody>
      </table>
    );
  }

  return false;
}
